// src/components/AboutProduct.js
import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './AboutProduct.css';

const AboutProduct = ({ subtitle, title, imageSrc, description }) => {
  const [subtitleRef, subtitleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [descriptionRef, descriptionVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <div className="about-product-container">
      <p 
        ref={subtitleRef}
        className={`about-product-subtitle scroll-fade-in ${subtitleVisible ? 'is-visible' : ''}`}
      >
        {subtitle}
      </p>
      <h2 
        ref={titleRef}
        className={`about-product-title scroll-fade-in scroll-animation-delay-1 ${titleVisible ? 'is-visible' : ''}`}
      >
        {title}
      </h2>
      <img src={imageSrc} alt="Product" className="about-product-image" />
      <p 
        ref={descriptionRef}
        className={`about-product-description scroll-fade-in scroll-animation-delay-2 ${descriptionVisible ? 'is-visible' : ''}`}
      >
        {description}
      </p>
    </div>
  );
};

export default AboutProduct;
